import { graphql } from 'gql.tada';

export const GET_CART_SUMMARY = graphql(`
    query cartSummary {
        cart {
            quantity
        }
    }
`);

export const GET_CART = graphql(`
    query cart {
        cart {
            identifier {
                id
            }
            price
            quantity
            programs {
                language
                price
                program {
                    identifier {
                        id
                    }
                    editorialization {
                        title
                    }
                    files {
                        coverUrl
                    }
                    duration
                    audioLanguages
                    production {
                        firstBroadcastDate
                        originalLanguage
                    }
                    parent {
                        identifier {
                            id
                        }
                        editorialization {
                            title
                        }
                        files {
                            coverUrl
                        }
                    }
                    episodeNumber
                    publicSeller {
                        legalName
                    }
                }
            }
        }
    }
`);

export const ADD_TO_CART = graphql(`
    mutation addToCart($input: AddToCartInput!) {
        cart {
            billing {
                addToCart(input: $input) {
                    identifier {
                        id
                    }
                    price
                    quantity
                    programs {
                        language
                        price
                        program {
                            identifier {
                                id
                            }
                            editorialization {
                                title
                            }
                            files {
                                coverUrl
                            }
                            duration
                            audioLanguages
                            production {
                                firstBroadcastDate
                                originalLanguage
                            }
                            parent {
                                identifier {
                                    id
                                }
                                editorialization {
                                    title
                                }
                                files {
                                    coverUrl
                                }
                            }
                            episodeNumber
                            publicSeller {
                                legalName
                            }
                        }
                    }
                }
            }
        }
    }
`);

export const REMOVE_FROM_CART = graphql(`
    mutation removeFromCart($input: RemoveFromCartInput!) {
        cart {
            billing {
                removeFromCart(input: $input) {
                    identifier {
                        id
                    }
                    price
                    quantity
                    programs {
                        language
                        price
                        program {
                            identifier {
                                id
                            }
                            editorialization {
                                title
                            }
                            files {
                                coverUrl
                            }
                            duration
                            audioLanguages
                            production {
                                firstBroadcastDate
                                originalLanguage
                            }
                            parent {
                                identifier {
                                    id
                                }
                                editorialization {
                                    title
                                }
                                files {
                                    coverUrl
                                }
                            }
                            episodeNumber
                            publicSeller {
                                legalName
                            }
                        }
                    }
                }
            }
        }
    }
`);

export const UPDATE_CART = graphql(`
    mutation updateCart($input: UpdateCartInput!) {
        cart {
            billing {
                updateCart(input: $input) {
                    identifier {
                        id
                    }
                    price
                    quantity
                    programs {
                        language
                        price
                        program {
                            identifier {
                                id
                            }
                            editorialization {
                                title
                            }
                            files {
                                coverUrl
                            }
                            duration
                            audioLanguages
                            production {
                                firstBroadcastDate
                                originalLanguage
                            }
                            parent {
                                identifier {
                                    id
                                }
                                editorialization {
                                    title
                                }
                                files {
                                    coverUrl
                                }
                            }
                            episodeNumber
                            publicSeller {
                                legalName
                            }
                        }
                    }
                }
            }
        }
    }
`);
